export default "__VITE_ASSET__v6SfWDnw__"